import React, { useState, useEffect, CSSProperties } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import Breakdown from '../charts/breakDown';
//import BreakdownDayData from '../../data/consumer/BreakdownDayData.json';
//import BreakdownWeekData from '../../data/consumer/BreakdownWeekData.json';
//import BreakdownYearData from '../../data/consumer/BreakdownYearData.json';
// Datepicker
import DatePicker from "react-datepicker";
import { getBreakdownData } from '../../services/consumer.service';
import moment from 'moment';
//import { AuthUser, selectUser } from '../../slices/auth.slice';
//import { useAppSelector } from '../../app/hooks';

import DotLoader from "react-spinners/DotLoader";
//import { START_DATE } from '../../prosumerComponents/common/const';

// Datepicker

const override: CSSProperties = {
    display: "block",
    margin: "auto",
    marginTop: "250px",
    marginBottom: "200px",
    borderColor: "red",
};

interface BreakdownObject {
    startDate: string,
    endDate: string,
    bill: {
        traded: number,
        energy_load: number
    },
    usage: {
        traded: number,
        energy_load: number
    }
}

const color = '#006837';

const BreakdownWidget = (props: any) => {

    const [loading, setLoading] = useState(false);

    const auth = JSON.parse(localStorage.getItem('auth')!)
    const [isChecked, setIsChecked] = useState(false);
    const [selectedDate, setSelectedDate] = useState('dst');
    const [startDate, setStartDate] = useState<Date>(() => {
        const date = new Date();
        date.setDate(date.getDate() - 1);
        return date;
    });

    // const [data, setData] = useState([])
    // const dateSelector = 'dst';

    const [breakDownDayData, setBreakDownDayData] = useState<BreakdownObject[]>([])
    const [breakDownWeekData, setBreakDownWeekData] = useState<BreakdownObject[]>([])
    const [breakDownYearData, setBreakDownYearData] = useState<BreakdownObject[]>([])

    const [daykWhDataListTraded, setdaykWhDataListTraded] = useState<any>()
    const [daykWhDataListEnergyLoad, setdaykWhDataListEnergyLoad] = useState<any>()
    const [dayCurrencyDataListTraded, setdayCurrencyDataListTraded] = useState<any>()
    const [dayCurrencyDataListEnergyLoad, setdayCurrencyDataListEnergyLoad] = useState<any>()

    const [weekkWhDataListTraded, setweekkWhDataListTraded] = useState<any>()
    const [weekkWhDataListEnergyLoad, setweekkWhDataListEnergyLoad] = useState<any>()
    const [weekCurrencyDataListTraded, setweekCurrencyDataListTraded] = useState<any>()
    const [weekCurrencyDataListEnergyLoad, setweekCurrencyDataListEnergyLoad] = useState<any>()

    const [yearkWhDataListTraded, setyearkWhDataListTraded] = useState<any>()
    const [yearkWhDataListEnergyLoad, setyearkWhDataListEnergyLoad] = useState<any>()
    const [yearCurrencyDataListTraded, setyearCurrencyDataListTraded] = useState<any>()
    const [yearCurrencyDataListEnergyLoad, setyearCurrencyDataListEnergyLoad] = useState<any>()

    let period24Data = breakDownDayData;
    let periodWeekData = breakDownWeekData;
    let periodYearData = breakDownYearData;

    let tradeData = daykWhDataListTraded;
    let EnergyLoadData = daykWhDataListEnergyLoad;
    // 24 hours period
    if (!isChecked && selectedDate === 'dst') {
        tradeData = daykWhDataListTraded;
        EnergyLoadData = daykWhDataListEnergyLoad;
    } else if (isChecked && selectedDate === 'dst') {
        tradeData = dayCurrencyDataListTraded;
        EnergyLoadData = dayCurrencyDataListEnergyLoad;
    }
    // Week
    else if (!isChecked && selectedDate === 'dsd') {
        tradeData = weekkWhDataListTraded;
        EnergyLoadData = weekkWhDataListEnergyLoad;
    } else if (isChecked && selectedDate === 'dsd') {
        tradeData = weekCurrencyDataListTraded;
        EnergyLoadData = weekCurrencyDataListEnergyLoad;
    }
    // Year
    else if (!isChecked && selectedDate === 'dsm') {
        tradeData = yearkWhDataListTraded;
        EnergyLoadData = yearkWhDataListEnergyLoad;
    } else if (isChecked && selectedDate === 'dsm') {
        tradeData = yearCurrencyDataListTraded;
        EnergyLoadData = yearCurrencyDataListEnergyLoad;
    }

    //get Labels 
    const daylabels = period24Data.map((data) => moment(data.startDate).format('H:mm'));
    const weeklabels = periodWeekData.map((data) => moment(data.startDate).format('DD MMM YY'));
    const yearlabels = periodYearData.map((data) => moment(data.endDate).format('MMM'));

    let labels = daylabels;

    if (selectedDate === 'dst') {
        labels = daylabels;
    }
    else if (selectedDate === 'dsd') {
        labels = weeklabels;
    }
    else if (selectedDate === 'dsm') {
        labels = yearlabels;
    }
    const { t, i18n } = useTranslation();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            const dayData = await getBreakdownData(auth?.userId, moment(new Date(startDate)).format('YYYY-MM-DD'), 'd', 1, props.userList);
            const weekData = await getBreakdownData(auth?.userId, moment(new Date(startDate)).format('YYYY-MM-DD'), 'w', 1, props.userList);
            const yearData = await getBreakdownData(auth?.userId, moment(new Date(startDate)).format('YYYY-MM-DD'), 'y', 1, props.userList);
            setBreakDownDayData(dayData.data);
            setBreakDownWeekData(weekData.data);
            setBreakDownYearData(yearData.data);

            setdaykWhDataListTraded(dayData.data
                .map((item: any) => item.usage.traded));
            setdaykWhDataListEnergyLoad(dayData.data
                .map((item: any) => item.usage.energy_load > 0 ? item.usage.energy_load : 0));
            setdayCurrencyDataListTraded(dayData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(startDate)).format('YYYY-MM-DD')) {
                    return item.bill.traded
                }
            }))
            setdayCurrencyDataListEnergyLoad(dayData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(startDate)).format('YYYY-MM-DD')) {
                    return item.bill.energy_load
                }
            }))

            setweekkWhDataListTraded(weekData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(startDate)).format('YYYY-MM')) {
                    return item.usage.traded
                }
            }))
            setweekkWhDataListEnergyLoad(weekData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(startDate)).format('YYYY-MM')) {
                    return item.usage.energy_load
                }
            }))
            setweekCurrencyDataListTraded(weekData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(startDate)).format('YYYY-MM')) {
                    return item.bill.traded
                }
            }))
            setweekCurrencyDataListEnergyLoad(weekData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(startDate)).format('YYYY-MM')) {
                    return item.bill.energy_load
                }
            }))

            setyearkWhDataListTraded(yearData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(startDate)).format('YYYY')) {
                    return item.usage.traded
                }
            }))
            setyearkWhDataListEnergyLoad(yearData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(startDate)).format('YYYY')) {
                    return item.usage.energy_load
                }
            }))
            setyearCurrencyDataListTraded(yearData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(startDate)).format('YYYY')) {
                    return item.bill.traded
                }
            }))
            setyearCurrencyDataListEnergyLoad(yearData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(startDate)).format('YYYY')) {
                    return item.bill.energy_load
                }
            }))
            setLoading(false);
        }
        fetchData();
        console.log(daykWhDataListTraded);
        console.log(daykWhDataListEnergyLoad);
        //filterDate(new Date(startDate).toString())

    }, [startDate, props.userList])

    // const filterDate = (date: string) => {
    //     //day
    //     const daykWhDataListTradedArray = breakDownDayData.map((item) => {
    //         if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(date)).format('YYYY-MM-DD')) {
    //             return item.usage.traded
    //         }
    //     })
    //     const daykWhDataListEnergyLoadArray = breakDownDayData.map((item) => {
    //         if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(date)).format('YYYY-MM-DD')) {
    //             return item.usage.energy_load
    //         }
    //     })

    //     const dayCurrencyDataListTradedArray = breakDownDayData.map((item) => {
    //         if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(date)).format('YYYY-MM-DD')) {
    //             return item.bill.traded
    //         }
    //     })

    //     const dayCurrencyDataListEnergyLoadArray = breakDownDayData.map((item) => {
    //         if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(date)).format('YYYY-MM-DD')) {
    //             return item.bill.energy_load
    //         }
    //     })

    //     //week
    //     const weekkWhDataListTradedArray = breakDownWeekData.map((item) => {
    //         if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(date)).format('YYYY-MM')) {
    //             return item.usage.traded
    //         }
    //     })

    //     const weekkWhDataListEnergyLoadArray = breakDownWeekData.map((item) => {
    //         if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(date)).format('YYYY-MM')) {
    //             return item.usage.energy_load
    //         }
    //     })

    //     const weekCurrencyDataListTradedArray = breakDownWeekData.map((item) => {
    //         if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(date)).format('YYYY-MM')) {
    //             return item.bill.traded
    //         }
    //     })

    //     const weekCurrencyDataListEnergyLoadArray = breakDownWeekData.map((item) => {
    //         if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(date)).format('YYYY-MM')) {
    //             return item.bill.energy_load
    //         }
    //     })

    //     //----------------

    //     const yearkWhDataListTradedArray = breakDownYearData.map((item) => {
    //         if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(date)).format('YYYY')) {
    //             return item.usage.traded
    //         }
    //     })


    //     const yearkWhDataListEnergyLoadArray = breakDownYearData.map((item) => {
    //         if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(date)).format('YYYY')) {
    //             return item.usage.energy_load
    //         }
    //     })


    //     const yearCurrencyDataListTradedArray = breakDownYearData.map((item) => {
    //         if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(date)).format('YYYY')) {
    //             return item.bill.traded
    //         }
    //     })


    //     const yearCurrencyDataListEnergyLoadArray = breakDownYearData.map((item) => {
    //         if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(date)).format('YYYY')) {
    //             return item.bill.energy_load
    //         }
    //     })


    //     setdaykWhDataListTraded(daykWhDataListTradedArray)
    //     setdaykWhDataListEnergyLoad(daykWhDataListEnergyLoadArray)
    //     setdayCurrencyDataListTraded(dayCurrencyDataListTradedArray)
    //     setdayCurrencyDataListEnergyLoad(dayCurrencyDataListEnergyLoadArray)
    //     setweekkWhDataListTraded(weekkWhDataListTradedArray)
    //     setweekkWhDataListEnergyLoad(weekkWhDataListEnergyLoadArray)
    //     setweekCurrencyDataListTraded(weekCurrencyDataListTradedArray)
    //     setweekCurrencyDataListEnergyLoad(weekCurrencyDataListEnergyLoadArray)
    //     setyearkWhDataListTraded(yearkWhDataListTradedArray)
    //     setyearkWhDataListEnergyLoad(yearkWhDataListEnergyLoadArray)
    //     setyearCurrencyDataListTraded(yearCurrencyDataListTradedArray)
    //     setyearCurrencyDataListEnergyLoad(yearCurrencyDataListEnergyLoadArray)


    // }

    return (
        <div className='dashboardWidget'>
            <div className='widgetTitle'>
                <Row>
                    <Col md="5" sm="12" className='mb-3 mb-sm-0'>
                        <h3>{t("dashboard:breakdownCard.title")}</h3>
                        <label className='reactdatepicker-label' htmlFor="reactDatePicker">
                            <DatePicker
                                dateFormat={selectedDate === 'dst' ? "eeee, dd MMM ′yy" : selectedDate == 'dsd' ? "MMM ′yy" : "yyyy"}
                                selected={startDate}
                                className="datepicker"
                                id='reactDatePicker'
                                showMonthYearPicker={selectedDate === 'dsd' ? true : false}
                                showYearPicker={selectedDate === 'dsm' ? true : false}
                                onChange={date => date && setStartDate(date)}
                            />
                        </label>
                        {/* <div className='dateChanger d-flex'>
                            <span className='dateRight'><i className="fa-solid fa-chevron-left"></i></span>
                            <span className='dateShow'>30 Sep’19</span>
                            <span className='dateLeft'><i className="fa-solid fa-chevron-right"></i></span>
                        </div> */}
                    </Col>
                    <Col md="7" sm="12">
                        <div className='d-flex align-items-center justify-content-end'>
                            <div className='dateSelector border-end pe-4'>
                                <Form.Check type="radio" id="dst" name='dateSelector' onChange={() => setSelectedDate('dst')} defaultChecked label="24" className='form-tag tag-primary' />
                                <Form.Check type="radio" id="dsd" name='dateSelector' onChange={() => setSelectedDate('dsd')} label="D" className='form-tag tag-primary' />
                                <Form.Check type="radio" id="dsm" name='dateSelector' onChange={() => setSelectedDate('dsm')} label="M" className='form-tag tag-primary' />
                            </div>
                            <div className='ps-4 switch d-flex align-items-center justify-content-end'>
                                <span className='d-block me-2'>kWh</span> <Form.Check type="switch" id="sbds" label="" onClick={() => setIsChecked(!isChecked)} /> <span className='d-block ms-2'>฿</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className='widgetBody'>
                {loading ? <DotLoader
                    color={color}
                    loading={loading}
                    cssOverride={override}
                    size={50}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                /> :
                    <Breakdown treadeData={tradeData} EnergyLoadData={EnergyLoadData} isChecked={isChecked} labels={labels} />
                }</div>
        </div>
    )
}
export default BreakdownWidget;